import React, { useState } from "react";
import SingleDatePicker from "../../SingleDatePicker/SingleDatePicker";
import CalendarIcon from "../../../assets/svg/calendar-icon";
import Button from "../../Button/Button";
import {
  FilterState,
  selectCampaignsFilters,
  setCampaignsStartedOn,
} from "../../../redux/slices/filterSlice";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentPage } from "../../../redux/slices/allCampaignSlice";

const CampaignStartsOnFilter = ({ onClose }: { onClose: () => void }) => {
  const campaignFilters = useSelector(
    (state: { filter: FilterState }) => selectCampaignsFilters(state)?.startedOn
  );
  const [selectedFromDate, setSelectedFromDate] = useState<string | null>(
    campaignFilters?.value?.from || null
  );
  const [selectedToDate, setSelectedToDate] = useState<string | null>(
    campaignFilters?.value?.to || null
  );
  const [openCalendar, setOpenCalendar] = useState<string | null>(null);
  const dispatch = useDispatch();

  const handleDateChange = (date: Date, isFromDate: boolean) => {
    if (isFromDate) {
      const startOfDay = new Date(date);
      startOfDay.setHours(0, 0, 0, 0);
      setSelectedFromDate(startOfDay.toISOString());
    } else {
      const endOfDay = new Date(date);
      endOfDay.setHours(23, 59, 59, 999);
      setSelectedToDate(endOfDay.toISOString());
    }
  };

  const handleApply = () => {
    if (
      selectedFromDate === campaignFilters?.value?.from &&
      selectedToDate === campaignFilters?.value?.to
    ) {
      return;
    }
    dispatch(
      setCampaignsStartedOn({
        value: { from: selectedFromDate || "", to: selectedToDate || "" },
        displayValue: {
          from: selectedFromDate || "",
          to: selectedToDate || "",
        },
      })
    );
    dispatch(setCurrentPage(1));
    onClose();
  };

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2 px-2 mt-2">
        <SingleDatePicker
          label="From"
          labelClassName="text-md text-verba-field-label dark:text-verba-field-label-dk"
          Icon={CalendarIcon}
          value={selectedFromDate}
          onChange={(date) => handleDateChange(date || new Date(), true)}
          containerClassName="w-full"
          maxDate={selectedToDate ? new Date(selectedToDate) : new Date()}
          isOpen={openCalendar === "from"}
          onOpenChange={(isOpen) => setOpenCalendar(isOpen ? "from" : null)}
          inputClassName="text-base font-normal text-heading-text dark:text-heading-text-dk bg-pure-white dark:bg-pure-white-dk border px-[12px] py-[8px] rounded-[8px] border border-border-gray dark:border-border-gray-dk"
        />

        <div className="w-full">
          <SingleDatePicker
            label="To"
            labelClassName="text-md  text-verba-field-label dark:text-verba-field-label-dk"
            Icon={CalendarIcon}
            value={selectedToDate}
            onChange={(date) => handleDateChange(date || new Date(), false)}
            containerClassName="w-full"
            minDate={selectedFromDate ? new Date(selectedFromDate) : undefined}
            maxDate={new Date()}
            isOpen={openCalendar === "to"}
            onOpenChange={(isOpen) => setOpenCalendar(isOpen ? "to" : null)}
            inputClassName="text-base font-normal text-heading-text dark:text-heading-text-dk bg-pure-white dark:bg-pure-white-dk border border-border-gray dark:border-border-gray-dk px-[12px] py-[8px] rounded-[8px] "
          />
        </div>
      </div>
      <div className="flex justify-end gap-2 mt-4">
        <Button
          innerText="Cancel"
          onClick={() => onClose()}
          buttonContainerClass="py-1 px-7.5 border border-verba-indigo dark:border-verba-indigo-dk rounded-lg"
          innerTextClass="text-md font-medium whitespace-nowrap text-heading-text dark:text-heading-text-dk"
        />
        <Button
          innerText="Apply"
          onClick={handleApply}
          disabled={
            !selectedFromDate ||
            !selectedToDate ||
            (selectedFromDate === campaignFilters?.value?.from &&
              selectedToDate === campaignFilters?.value?.to)
          }
          buttonContainerClass="py-1 px-7.5 rounded-lg bg-verba-indigo dark:bg-verba-indigo-dk disabled:opacity-50 disabled:cursor-not-allowed"
          innerTextClass="text-md font-medium whitespace-nowrap text-pure-white dark:text-pure-white-dk"
        />
      </div>
    </div>
  );
};

export default CampaignStartsOnFilter;
